import { buildTemplatePicker, type TemplatePicker } from "../core/render.js";

/**
 * Collects a search block's authored card templates and removes them from the
 * DOM — unlike a CMS list there is no server-rendered content here, only
 * design-time scaffolding that must not stay visible.
 *
 * `data-slater-template` (no value) is the default card. A valued one —
 * `data-slater-template="blog"`, or the reserved `"page"` for static pages —
 * renders only results of that collection, so cross-collection results can
 * carry different layouts and link patterns. The collection/removal logic
 * lives in core's `buildTemplatePicker`, shared with group lists (which keep
 * their originals in place instead — see that function's doc).
 */
export function findSearchTemplates(results: Element): TemplatePicker | null {
  return buildTemplatePicker(results, true);
}
